<template>
  <div>
    <az-panel>
      <template slot="lft">
        <el-button type="primary" icon="el-icon-refresh" size="medium"
          @click="renderList">刷新</el-button>
      </template>
    </az-panel>
    <el-table
      :data="tableList"
      ref="orderList"
      stripe
      size="small"
      style="width: 100%;">
      <el-table-column
        prop="id"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="name"
        label="审批类型名">
      </el-table-column>
      <el-table-column
        prop="order_count"
        label="审批流程状态">
        <template slot-scope="scope">
          {{approvalStatus.constMap.idMap[scope.row.status].name}}
          <!-- {{scope.row.order_count || '0'}} 个 -->
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本">
      </el-table-column>
      <!-- <el-table-column
        prop="org_groups_count"
        label="关联用户/部门个数">
        <template slot-scope="scope">
          {{scope.row.org_groups_count || '0'}} 个
        </template>
      </el-table-column> -->
      <el-table-column
        align="right"
        width="160"
        label="操作">
        <template slot-scope="scope">
          <!-- <ag-link>编辑</ag-link>
          <ag-link>编辑流程</ag-link> -->
          <az-button size="mini" type="editBase"
            content="修改基本信息"
            @click.native="$router.push(`/approval/project/base-edit?type=${scope.row.type}&id=${scope.row.id}`)">
          </az-button>
          <az-button size="mini" type="edit" content="编辑审批流程"
            @click.native="editHandler(scope.row)"></az-button>

        </template>
      </el-table-column>
      <template slot="empty">
        <az-loading v-if="isLoading"></az-loading>
        <div v-else>暂无数据</div>
      </template>
    </el-table>
    <div class="az-pagination clearfix">
    </div>
  </div>
</template>
<script>
import azButton from '@/base/azButton.vue';
import { getApprovalList } from '@/api/approval'
import { approvalStatus } from '@/const'

export default {
  name: 'projectList',
  components: {
    azButton
  },
  data() {
    return {
      approvalStatus,
      tableList: [],
      isLoading: true,
      cancel: null,
      total: 0,
      pageInfo: {
        page: 1,
        per_page: 10,
      }
    }
  },
  methods: {
    handleSelectionChange(checkeds) {
      this.checkeds = checkeds;
    },
    resetPageGoPage() {

    },
    goPage() {

    },
    editHandler(row) {
      console.log('row', row)
      this.$router.push(`/approval/project/flow?type=${row.type}&type_name=${encodeURI(row.name)}`)
      // this.$refs['orgCardDialogRef'].$emit('edit', row.id);
    },
    toCancel() {
      if (this.cancel) {
        this.cancel();
      }
    },
    initParams(route) {
      this.pageInfo.page = route.query.page - 0 || 1;
      this.pageInfo.per_page = route.query.per_page - 0 || 10;
      this.pageInfo.search_value = route.query.search_value || '';
      this.pageInfo.org_group_id = route.query.org_group_id - 0 || '';
    },

    renderList() {
      this.isLoading = true;
      this.tableList = []
      getApprovalList().then(res => {
        if (res.code != 0 || !res.data) throw new Error(res.message)
        res.data
        this.tableList = res.data
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => this.isLoading = false)
      return
    },
  },

  beforeRouteUpdate(to, from, next) {
    // this.initParams(to);
    this.renderList();
    next();
  },

  created() {
    this.renderList()
  }
}
</script>